// extracted by mini-css-extract-plugin
module.exports = {"searchDialog":"SearchDialog_searchDialog__mJNel","hidden":"SearchDialog_hidden__CBh3G","resultsContainer":"SearchDialog_resultsContainer__8ic0T"};